const createdByMap = {
  carrierMobile: 'Amous Carrier Tracking',
};

export {
  createdByMap,
};
